import { getApiClient, ReportGenerationSucceededEventArgs, showToast, ViewModelMessageType } from '@neos/core'
import { cast, getEventManager, stringFormat, tryGetValue } from '@neos/shared'
import PrintJob from '@src/dataObjects/PrintJob'
import PrintJobResult from '@src/dataObjects/PrintJobResult'
import { invokeHybridAppCommand } from '@neos/hybrid-app'
import { PrintJobResultCode } from '@src/enums/PrintJobResultCode'
import { getApplicationResourceManager } from '@neos/app'

/**
 * On report generation succeeded async.
 * 
 * @param args Args.
 */
export async function userPermissionsOnReportGenerationSucceededAsync(args: ReportGenerationSucceededEventArgs): Promise<void> {
  let printJobsObj = { value: null };
  if (args.reportOptions != null && args.reportOptions.clientContext != null && tryGetValue(args.reportOptions.clientContext, 'PrintJobs', printJobsObj)) {
    let printJobs: PrintJob[] = cast<PrintJob[]>(printJobsObj.value);
    args.displayToast = false;
    let fileContent: number[] = await getApiClient('siga-activation').getByteArrayAsync(args.fileUrl);
    try {
      let results: PrintJobResult[] = await invokeHybridAppCommand<PrintJobResult[]>('print_file', { fileName: `${args.fileIdentifier}.pdf`, fileContent: fileContent, printJobs: printJobs });
      for (let result of results) {
        switch (result.code) {
  case PrintJobResultCode.printSucceeded:
  showToast(getEventManager(), ViewModelMessageType.positive, getApplicationResourceManager('siga-activation').get('modules.UserPermissions.ReportPrint_ToastTitle'), stringFormat(getApplicationResourceManager('siga-activation').get('modules.UserPermissions.ReportPrintJob_PrintSucceeded'), result.printerName));
  break;
  case PrintJobResultCode.printerNotFound:
  showToast(getEventManager(), ViewModelMessageType.danger, getApplicationResourceManager('siga-activation').get('modules.UserPermissions.ReportPrint_ToastTitle'), stringFormat(getApplicationResourceManager('siga-activation').get('modules.UserPermissions.ReportPrintJob_PrinterNotFound'), result.printerName), 0);
  break;
  default:
  showToast(getEventManager(), ViewModelMessageType.danger, getApplicationResourceManager('siga-activation').get('modules.UserPermissions.ReportPrint_ToastTitle'), stringFormat(getApplicationResourceManager('siga-activation').get('modules.UserPermissions.ReportPrintJob_PrintFailed'), result.printerName), 0);
  break;
  }
      }
    }
  catch {
      showToast(getEventManager(), ViewModelMessageType.danger, getApplicationResourceManager('siga-activation').get('modules.UserPermissions.ReportPrint_ToastTitle'), getApplicationResourceManager('siga-activation').get('modules.UserPermissions.ReportPrint_PrintFailed'), 0);
    }
  }
}
